
import * as cloudflareCustomRuntime$ps1trbv0oZISBYIJGLaerIgG5h2cddKZjbL6wfgYv50 from '/vercel/path0/providers/cloudflare-custom.ts'

export const imageOptions = {
  "screens": {
    "xs": 100,
    "sm": 128,
    "md": 256,
    "lg": 512,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "cloudflareCustom",
  "domains": [
    "s3.styletpff.com",
    "musics3.styletpff.com"
  ],
  "alias": {},
  "densities": [
    1,
    2,
    1,
    2
  ],
  "format": [
    "webp",
    "avif",
    "jpg",
    "png",
    "webp"
  ],
  "quality": 80
}

imageOptions.providers = {
  ['cloudflareCustom']: { provider: cloudflareCustomRuntime$ps1trbv0oZISBYIJGLaerIgG5h2cddKZjbL6wfgYv50, defaults: {"baseURL":"https://musics3.styletpff.com"} }
}
        